<template>
  <div class="container">
    <h1>Barbers</h1>
    <b-row>
      <b-col>
        <b-form class="d-flex mb-2" inline @submit.prevent>
          <b-form-select
            id="resources__perPage"
            class="mb-0"
            v-model="perPage"
            :options="perPageOptions"
            aria-label="Per page"
            aria-controls="resources-table"
          ></b-form-select>
          <b-form-input
            id="resources__searchQuery"
            class="ml-sm-2 col-md-2 mb-0"
            v-model="searchQuery"
            placeholder="Search..."
            aria-label="Search"
            aria-controls="resources-table"
          ></b-form-input>
          <router-link
            v-if="resources.length"
            class="ml-auto btn btn-primary"
            :to="{ name: 'resources/add' }"
          >
            Add Barber
          </router-link>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          id="resources__table"
          :items="resources"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="searchQuery"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="loading"
          :show-empty="!loading && !resources.length"
          stacked="md"
          striped
          @filtered="
            filteredItems => (searchItemsLength = filteredItems.length)
          "
        >
          <template v-slot:cell(name)="data">
            <router-link
              tag="a"
              :to="{ name: 'resources/edit', params: { id: data.item._id } }"
              >{{ data.item.name }}</router-link
            >
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
              size="sm"
              variant="link"
              class="m-0 p-0 text-muted"
              @click.prevent="confirmDeleteResource(data.item)"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:empty>
            <div v-if="error" class="text-center text-danger my-2">
              <p>Something went wrong, please try again later.</p>
            </div>
            <div v-else class="text-center text-primary my-2">
              <p>You don't have any Barbers yet.</p>
              <router-link
                :to="{ name: 'resources/add' }"
                class="btn btn-primary"
              >
                Add a Barber
              </router-link>
            </div>
          </template>
        </b-table>
        <b-pagination
          id="resources__pagination"
          v-model="currentPage"
          :total-rows="resources.length"
          :per-page="perPage"
          align="right"
          aria-controls="resources-table"
          first-number
          last-number
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { timestampToDateAndTime } from '@/time';

export default {
  name: 'AdminResources',
  data() {
    return {
      loading: true,
      error: null,
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'availableForOnlineBookings',
          label: 'Online Bookings',
          sortable: true,
          formatter: value => (value ? 'Yes' : 'No')
        },
        {
          key: 'timestamp',
          label: 'Last Modified',
          sortable: true,
          formatter: timestampToDateAndTime
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      searchQuery: null,
      searchItemsLength: 0,
      sortBy: 'name',
      sortDesc: false,
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50]
    };
  },
  methods: {
    ...mapActions({
      fetchResources: 'resources/fetchResources',
      deleteResource: 'resources/deleteResource'
    }),
    async confirmDeleteResource(resource) {
      let result = await this.$swal({
        type: 'warning',
        title: 'Are you sure?',
        text: `The Barber "${resource.name}" will be permanently deleted.`,
        showCancelButton: true
      });

      if (!result.value) return;

      try {
        await this.deleteResource(resource);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Barber deleted.'
        });
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      }
    }
  },
  computed: mapGetters({
    resources: 'resources/resourcesList'
  }),
  async created() {
    try {
      await this.fetchResources();
    } catch (e) {
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }
};
</script>
